import { Box, Drawer, Tab, Typography } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import BadgeIcon from '@mui/icons-material/Badge';
import Licenses from '@views/pages/Admin/Provider/components/ProviderItem/Licenses.tsx';
import { TabList, TabContext, TabPanel } from '@mui/lab';
import { useProviderItem } from './hooks';
import { History } from 'components/History/';
import { General } from './General';
import { t } from 'i18next';

interface ProviderItemProps {
  open: boolean;
  handleClose: () => void;
  itemId: string;
}

export const ProviderItem = ({
  open,
  handleClose,
  itemId,
}: ProviderItemProps) => {
  const {
    handleTriggerChangeTab,
    tabIndex,
    provider,
    providerHistory,
    historyPage,
    setHistoryPage,
    handleCloseTrigger,
    historyTabIndex,
    isProviderInactive,
    setIsProviderInactive,
  } = useProviderItem({
    id: itemId,
    handleClose,
  });

  const licensesCount = provider?.data?.licenses.length
    ? provider?.data.licenses.length
    : 0;

  return (
    <Drawer
      ModalProps={{ onClose: handleCloseTrigger }}
      anchor='right'
      open={open}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '600px',
          height: '100%',
          paddingX: 3,
          paddingY: 3,
          overflowY: 'auto',
          scrollbarWidth: 'thin',
        }}
      >
        {provider?.data && (
          <>
            <Box
              sx={{
                display: 'flex',
                position: 'relative',
                justifyContent: 'space-between',
                width: '100%',
                padding: '0',
                pb: '1rem',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <BadgeIcon
                  sx={{ width: '36px', height: '36px' }}
                  color={isProviderInactive ? 'disabled' : 'primary'}
                />

                <Box
                  sx={{ display: 'flex', flexDirection: 'column', pl: '1rem' }}
                >
                  <Typography
                    variant='body1'
                    sx={{
                      color: isProviderInactive
                        ? 'text.disabled'
                        : 'text.primary',
                    }}
                  >
                    {`${provider.data.first_name} ${provider.data.last_name} ${provider.data.suffix} ${isProviderInactive ? '(inactive)' : ''}`}
                  </Typography>
                  <Typography
                    variant='body2'
                    sx={{
                      color: isProviderInactive
                        ? 'text.disabled'
                        : 'text.primary',
                    }}
                  >
                    {t('adminPanel.providers.providerItem.title')}
                  </Typography>
                </Box>
              </Box>

              <Box
                onClick={handleCloseTrigger}
                sx={{
                  justifyContent: 'center',
                  alignItems: 'center',
                  display: 'flex',
                  ':hover': {
                    cursor: 'pointer',
                    bgcolor: theme => theme.palette.grey[50],
                    borderRadius: '6px',
                  },
                  height: '30px',
                  width: '30px',
                }}
              >
                <ClearIcon />
              </Box>
            </Box>
            <TabContext value={tabIndex}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                <TabList onChange={handleTriggerChangeTab}>
                  <Tab
                    label={t(
                      'adminPanel.providers.providerItem.tabs.general.title',
                    )}
                    value='1'
                  />
                  <Tab
                    label={t(
                      'adminPanel.providers.providerItem.tabs.licenses.title',
                      { count: licensesCount },
                    )}
                    value='2'
                  />
                  {/* <Tab
                    label={t(
                      'adminPanel.providers.providerItem.tabs.careManager.title',
                    )}
                    value='3'
                  /> */}
                  <Tab
                    label={t(
                      'adminPanel.providers.providerItem.tabs.history.title',
                    )}
                    value={historyTabIndex}
                  />
                </TabList>
              </Box>
              <TabPanel
                sx={{
                  padding: '0 !important',
                }}
                value='1'
              >
                <Box
                  sx={{
                    maxHeight: 'calc(100vh - 180px)',
                    overflowY: 'auto',
                    pt: 1,
                  }}
                >
                  <General
                    provider={provider.data}
                    setIsProviderInactive={setIsProviderInactive}
                  />
                </Box>
              </TabPanel>
              <TabPanel
                sx={{
                  padding: '0 !important',
                }}
                value='2'
              >
                <Box
                  sx={{
                    maxHeight: 'calc(100vh - 180px)',
                    overflowY: 'auto',
                    pt: 1,
                  }}
                >
                  <Licenses provider={provider.data} />
                </Box>
              </TabPanel>
              {/* <TabPanel
                sx={{
                  padding: '0 !important' }}
                value='3'
              >
                <Box
                  sx={{
                    maxHeight: 'calc(100vh - 180px)',
                    overflowY: 'auto',
                    pt: 1 }}
                >
                  <CareManager provider={provider.data} />
                </Box>
              </TabPanel> */}
              <TabPanel
                sx={{
                  padding: '0 !important',
                }}
                value={historyTabIndex}
              >
                <Box
                  sx={{
                    maxHeight: 'calc(100vh - 180px)',
                    overflowY: 'auto',
                  }}
                >
                  {providerHistory && (
                    <History
                      page={historyPage}
                      changePage={setHistoryPage}
                      history={providerHistory.history}
                      count={providerHistory.count}
                    />
                  )}
                </Box>
              </TabPanel>
            </TabContext>
          </>
        )}
      </Box>
    </Drawer>
  );
};
